/**
 * Abre em modal os videos de "Quem comprou amou".
 *
 * O card ja e um <button data-ugc-video="url">, entao sem JS ele apenas nao
 * abre nada — a foto de capa continua visivel.
 *
 * Delegacao no document para cobrir cards que chegam depois (re-render de
 * section no editor de temas, troca de variante).
 */
(function () {
  if (window.__bsUgcReady) return;
  window.__bsUgcReady = true;

  var fundo = null;

  function fechar() {
    if (!fundo) return;
    fundo.remove();
    fundo = null;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', aoTeclar);
  }

  function aoTeclar(evento) {
    if (evento.key === 'Escape') fechar();
  }

  function abrir(url, rotulo) {
    fechar();

    fundo = document.createElement('div');
    fundo.className = 'm-ugc-modal';
    fundo.setAttribute('role', 'dialog');
    fundo.setAttribute('aria-modal', 'true');
    fundo.setAttribute('aria-label', rotulo || 'Video');

    var caixa = document.createElement('div');
    caixa.className = 'm-ugc-modal__box';

    var fechaBtn = document.createElement('button');
    fechaBtn.type = 'button';
    fechaBtn.className = 'm-ugc-modal__close';
    fechaBtn.setAttribute('aria-label', 'Fechar');
    fechaBtn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

    var video = document.createElement('video');
    video.className = 'm-ugc-modal__video';
    video.src = url;
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;

    caixa.appendChild(video);
    caixa.appendChild(fechaBtn);
    fundo.appendChild(caixa);
    document.body.appendChild(fundo);
    document.body.style.overflow = 'hidden';

    fechaBtn.addEventListener('click', fechar);
    fundo.addEventListener('click', function (evento) {
      if (evento.target === fundo) fechar();
    });
    document.addEventListener('keydown', aoTeclar);
    fechaBtn.focus();
  }

  document.addEventListener('click', function (evento) {
    var alvo = evento.target.closest('[data-ugc-video]');
    if (!alvo) return;
    evento.preventDefault();
    abrir(alvo.dataset.ugcVideo, alvo.getAttribute('aria-label'));
  });
})();
